import http from '@/http-common'

export default {
  name: "SmetaTab",
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    smetaEkp: {
      type: Object,
      default: null
    },
    eventkind_id: {
      type: Number,
      default: 0
    },
    costParent_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectMode: 'single',
      selected: [],
      costs: [],
      selectedItem: null,
      activeIndexDoc: -1,
      modalPdfDialogOpened: false,
      confirm_dialog: false,
      selectCost: null,
      titleConfirm: 'оплаченную'
    }
  },
  created() {
    this.loadCosts();
  },
  methods: {
    iconVal: function (row) {
      if (row.detailsShowing) {
        return 'chevron-up';
      } else {
        return 'chevron-down';
      }
    },
    titleVal: function (row) {
      if (row.detailsShowing) {
        return 'Скрыть подразделы';
      } else {
        return 'Показать подразделы';
      }
    },
    titleLabel(rec) {
      if (rec.norma > 0 && rec.norma < rec.summa) {
        return 'Сумма превышает норму';
      } else {
        return ''
      }
    },
    textLabel(rec) {
      return {
        'text-center text-danger': rec.norma > 0 && rec.norma < rec.summa,
        'text-center': rec.norma >= rec.summa || rec.norma <= 0
      }
    },
    summNormItog(rec) {
      let norm = rec.norma * rec.countPeople * rec.countDays;
      return norm.toFixed(2);
    },
    summSmetaRow(rec) {
      let ss = rec.summa * rec.countPeople * rec.countDays;
      return ss.toFixed(2);
    },
    changeSmetaRow(rec, index) {
      rec.summa = (rec.summa.match(/^\d*(\.?\d{0,2})/g)[0]) || 0
      rec.countPeople = Math.floor(rec.countPeople) || 0
      rec.countDays = Math.floor(rec.countDays) || 0

      if (rec.norma > 0 && rec.norma < rec.summa) {
        this.smetaEkp.details[index].summa = rec.norma;
      }
    },
    oninput(e) {
      // Фильтруем два знака после запятой по регулярному
      e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
      console.log('e', e.target.value)
    },
    loadCosts() {
      let vm = this;
      let filt = '';
      if (this.costParent_id != null) {
        filt = "&parent_id=" + this.costParent_id;
      }
      http.get('/cost/list?event_kind_id=' + this.eventkind_id + filt)
      .then((response) => {
        vm.costs = [];
        response.data.forEach(function (x) {
          x.value = x.id;
          x.text = x.analyticCode + ' - ' + x.nameCost;
          if (x.childs.length > 0) {
            x.disabled = true;
            vm.costs.push(x);
            x.childs.forEach(function (z) {
              z.value = z.id;
              z.text = ' - ' + x.nameCost + ' - ' + z.nameCost;
              vm.costs.push(z);
            })
          } else {
            vm.costs.push(x);
          }
        })
      })
      .catch((error) => console.log(error.response.data));
    },
    changeCost(rec, index) {
      const idx = this.costs.map(e => e.id).indexOf(rec.cost_id);
      if (idx >= 0) {
        var usePercent = this.costs[idx].usePercent;
        this.smetaEkp.details[index].norma = this.costs[idx].norma;
        this.smetaEkp.details[index].usePercent = usePercent;
      }
    },
    deleteRowDet(index) {
      this.smetaEkp.details.splice(index, 1)
    },
    editDocRow(val) {
      this.selectedItem.keyFile = val
      this.items[this.activeIndexDoc].keyFile = val
    },
    addSmetaRow() {
      this.$emit('addRow')
    },
    showConfirmMess(val) {
      this.selectCost = val;
      if (val.checkDocument) {
        this.titleConfirm = 'Отменить оплату статьи?'
      } else {
        this.titleConfirm = 'Принять статью, как оплаченную?'
      }

      this.confirm_dialog = !this.confirm_dialog;
    },
    closeEvent() {
      this.selectCost.checkDocument = !this.selectCost.checkDocument
    }
  }
}
